import * as Yup from 'yup'
import { notificationValidation } from '../../../../../../../forms/ReusableFormFields/RecipientsFields/validation'

export const validationSchema = Yup.object({
  ...notificationValidation
})
